import { atom, AtomEffect, DefaultValue } from 'recoil'

import { PersistService } from './PersistService'

export const sessionStorageEffect =
  (key: unknown): AtomEffect<any> =>
  ({ setSelf, onSet }): void => {
    const storedValue = PersistService.fetch(key)
    if (storedValue !== null) {
      setSelf(storedValue)
    }

    onSet((newValue: unknown) => {
      if (newValue instanceof DefaultValue) {
        PersistService.delete(key)
      } else {
        PersistService.store(key, newValue)
      }
    })
  }

export const localStorageEffect =
  (key: unknown): AtomEffect<any> =>
  ({ setSelf, onSet }): void => {
    const storedValue = PersistService.fetch(key, 'local')
    if (storedValue !== null) {
      setSelf(storedValue)
    }

    onSet((newValue: unknown) => {
      if (newValue instanceof DefaultValue) {
        PersistService.delete(key, 'local')
      } else {
        PersistService.store(key, newValue, 'local')
      }
    })
  }

export const langState = atom({
  key: 'lang',
  default: '',
  effects: [localStorageEffect('language')],
})

export const marketState = atom({
  key: 'market',
  default: 'CA',
  effects: [localStorageEffect('market')],
})

export const sideMenuLayoutState = atom({
  key: 'side_menu_layout',
  default: true,
})

export const initializationState = atom({
  key: 'initializedTokens',
  default: false,
  effects: [
    ({ setSelf }) => {
      const customer = PersistService.fetch('authenticated_customer', 'local')
      setSelf(!!customer)
    },
  ],
})

export const reachedUrlState = atom<string | null>({
  key: 'reached_url',
  default: null,
  effects: [sessionStorageEffect('reached_url')],
})

export const customerEmail = atom<string | null>({
  key: 'customer_email',
  default: null,
  effects: [sessionStorageEffect('customer_email')],
})

export const customerHmac = atom<string | null>({
  key: 'customer_hmac',
  default: null,
  effects: [sessionStorageEffect('customer_hmac')],
})

export const customerGUID = atom<string | null>({
  key: 'customer_guid',
  default: null,
  effects: [sessionStorageEffect('customer_guid')],
})

export const debugSuspense = atom<any>({
  key: 'debugger',
  default: {},
  effects: [
    ({ setSelf }) => {
      const promise = new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            continent: 'Africa',
            length: '6,650 km',
            outflow: 'Mediterranean',
          })
        }, 10 * 60000)
      })
      setSelf(promise)
    },
  ],
})
